<template>
  <snappy-table
    :endpoint="endpointUrl"
    :columns="['type', 'campaign', 'audience', 'initiated_at', 'status', 'finished_at']"
    :template-methods="columnTemplates(timezone)"
    :handle-row-click="onRowClick"
    :headings="['Type', 'Campaign', 'Audience', 'Started', 'Status', 'Finished']"
    record-type="Imports"
    :search-hidden="true"
  >
  </snappy-table>
</template>

<script>
import SnappyTable from '../../SnappyTable';
import columnTemplates from '../../../mixins/tables/columnTemplates';

export default {
  name: 'contact-imports-table',
  components: {SnappyTable},
  mixins: [columnTemplates],
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    parentImportId: {
      type: Number,
      required: false,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  computed: {
    endpointUrl() {
      return `vessels/${this.vesselId}/employees/${this.userId}/import/reports`;
    },
  },
  methods: {
    onRowClick(event) {
      const id = event.row.id;
      const token = btoa(`import_id=${id}`);
      window.location.assign(`/inventory/contacts/imports/report?sk_token=${token}`);
    },
  },
};
</script>
